module.exports = __webpack_public_path__ + "img/cuff length.e10a3918.png";